import Vue from 'vue';
import axios from 'axios';
import { getToken, setToken } from '@/util/auth';
import { setStore } from '@/util/store';
import { serialize } from '@/util/util';
import router from '@/router/index';
import { Toast } from 'vant';
Vue.use(Toast);

// 请求地址
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// 默认超时时间
axios.defaults.timeout = 10000;
// 返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};

// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

// http request拦截
axios.interceptors.request.use(config => {
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  // config.headers['Authorization'] = `Basic c2FiZXI6c2FiZXJfc2VjcmV0`;
  // 让每个请求携带token
  if (getToken() && !isToken) {
    config.headers['token'] = getToken()
  }

  // headers中配置text请求
  if (config.text === true) {
    config.headers["Content-Type"] = "text/plain";
  }

  // headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }

  return config
}, error => {
  return Promise.reject(error)
});

// http response 拦截
axios.interceptors.response.use(res => {
  // 获取状态码
  const status = res.data.code || res.status;
  const message = res.data.msg || res.data.error_description || '未知错误';

  // 如果是401则跳转到登录页面
  if (status === 401) {
    setToken('');
    setStore({name: 'token', content: ''});
    router.push({path: '/login'});
  }

  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    Toast.fail(message);

    return Promise.reject(new Error(message))
  }

  return res;
}, error => {
  console.log(error);
  if (error && error.stack.indexOf('timeout') > -1) {
    Toast.fail('网络连接错误');  
  } else {
    Toast.fail(error);
  }
  
  return Promise.reject(new Error(error));
});

export default axios;